/* jshint esnext: true */
import AbstractModule from './AbstractModule';

export default class extends AbstractModule {
    constructor (options) {
        super(options);
        this.openClass = 'has-services-open';

        this.$document.on('toggleServices.Services', (event, value) => {
            this.toggleSearch(value);
        });
    }

    /**
     * Toggles class on body that determines if Services are visible or not
     * @param  boolean|mixed  State
     */
    toggleSearch(state) {
        if (typeof state !== 'undefined' && typeof state === 'boolean') {
            this.$body.toggleClass(this.openClass, state);
        } else {
            this.$body.toggleClass(this.openClass);
        }
    }

    destroy() {
        this.$document.off('.Services');
    }
}
